// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-form-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.capacity-badge {
    padding: 12px 16px;
    border-radius: 12px;
    font-size: 0.95rem;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 12px;
    line-height: 1.4;
}

.capacity-badge.info {
    background-color: #EFF6FF;
    color: #1E40AF;
    border: 1px solid #DBEAFE;
}

.capacity-badge.waitlist {
    background-color: #FFFBEB;
    color: #92400E;
    border: 1px solid #FEF3C7;
}

.error-banner {
    background-color: #FEF2F2;
    border: 1px solid #FECACA;
    color: var(--error);
    padding: 12px;
    border-radius: 12px;
    font-size: 0.9rem;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.form-group {
    width: 100%;
    position: relative;
}

.form-group label {
    display: block;
    margin-bottom: 6px;
    font-size: 0.9rem;
    color: var(--text-muted);
    font-weight: 500;
}

.custom-select {
    width: 100%;
    height: 52px;
    padding: 0 16px;
    background-color: var(--bg-input);
    border: 1px solid var(--border-light);
    border-radius: var(--radius-input);
    font-size: 1rem;
    color: var(--text-main);
    appearance: none;
    cursor: pointer;
    transition: var(--transition);
}

.custom-select:focus {
    outline: none;
    border-color: var(--brand-primary);
    box-shadow: var(--shadow-input-focus);
    background-color: #fff;
}

.custom-select:disabled {
    background-color: #E2E8F0;
    cursor: not-allowed;
    opacity: 0.7;
}

.select-wrapper::after {
    content: '\\f107';
    font-family: 'FontAwesome';
    position: absolute;
    right: 16px;
    bottom: 16px;
    color: var(--text-muted);
    pointer-events: none;
}

.btn-register-action {
    width: 100%;
    height: 54px;
    background-color: var(--brand-primary);
    color: white;
    border: none;
    border-radius: var(--radius-input);
    font-size: 1.1rem;
    font-weight: 700;
    cursor: pointer;
    transition: var(--transition);
    box-shadow: 0 4px 10px rgba(0,0,0,0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.btn-register-action.is-waitlist {
    background-color: #F59E0B;
    color: white;
}

.btn-register-action:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 14px rgba(0,0,0,0.2);
    filter: brightness(1.1);
}

.btn-register-action:disabled {
    background-color: #CBD5E1;
    color: #94A3B8;
    transform: none;
    box-shadow: none;
    cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/AmericanaRegisterForm.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iCAAiC;IACjC,qCAAqC;IACrC,kCAAkC;IAClC,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,qCAAqC;IACrC,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,YAAY;IACZ,YAAY;IACZ,kCAAkC;IAClC,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,uCAAuC;IACvC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB","sourcesContent":[".register-form-wrapper {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.capacity-badge {\n    padding: 12px 16px;\n    border-radius: 12px;\n    font-size: 0.95rem;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    line-height: 1.4;\n}\n\n.capacity-badge.info {\n    background-color: #EFF6FF;\n    color: #1E40AF;\n    border: 1px solid #DBEAFE;\n}\n\n.capacity-badge.waitlist {\n    background-color: #FFFBEB;\n    color: #92400E;\n    border: 1px solid #FEF3C7;\n}\n\n.error-banner {\n    background-color: #FEF2F2;\n    border: 1px solid #FECACA;\n    color: var(--error);\n    padding: 12px;\n    border-radius: 12px;\n    font-size: 0.9rem;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n.form-group {\n    width: 100%;\n    position: relative;\n}\n\n.form-group label {\n    display: block;\n    margin-bottom: 6px;\n    font-size: 0.9rem;\n    color: var(--text-muted);\n    font-weight: 500;\n}\n\n.custom-select {\n    width: 100%;\n    height: 52px;\n    padding: 0 16px;\n    background-color: var(--bg-input);\n    border: 1px solid var(--border-light);\n    border-radius: var(--radius-input);\n    font-size: 1rem;\n    color: var(--text-main);\n    appearance: none;\n    cursor: pointer;\n    transition: var(--transition);\n}\n\n.custom-select:focus {\n    outline: none;\n    border-color: var(--brand-primary);\n    box-shadow: var(--shadow-input-focus);\n    background-color: #fff;\n}\n\n.custom-select:disabled {\n    background-color: #E2E8F0;\n    cursor: not-allowed;\n    opacity: 0.7;\n}\n\n.select-wrapper::after {\n    content: '\\f107';\n    font-family: 'FontAwesome';\n    position: absolute;\n    right: 16px;\n    bottom: 16px;\n    color: var(--text-muted);\n    pointer-events: none;\n}\n\n.btn-register-action {\n    width: 100%;\n    height: 54px;\n    background-color: var(--brand-primary);\n    color: white;\n    border: none;\n    border-radius: var(--radius-input);\n    font-size: 1.1rem;\n    font-weight: 700;\n    cursor: pointer;\n    transition: var(--transition);\n    box-shadow: 0 4px 10px rgba(0,0,0,0.15);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n}\n\n.btn-register-action.is-waitlist {\n    background-color: #F59E0B;\n    color: white;\n}\n\n.btn-register-action:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 14px rgba(0,0,0,0.2);\n    filter: brightness(1.1);\n}\n\n.btn-register-action:disabled {\n    background-color: #CBD5E1;\n    color: #94A3B8;\n    transform: none;\n    box-shadow: none;\n    cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
